module.exports = __webpack_public_path__ + "static/media/right-menu-notification-icon.c7c459fd.svg";